import { useEffect } from "react";
import { useLayout } from "../context/System/LayoutContext";

export const useDashboardF4Shortcut = () => {
    const { handleClickGoTo } = useLayout();

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.altKey || event.ctrlKey || event.metaKey) return;
            if (event.key?.trim().toUpperCase() !== "F4") return;

            event.preventDefault();
            event.stopPropagation();
            handleClickGoTo("/");
        };

        window.addEventListener("keydown", handleKeyDown, true);
        return () => window.removeEventListener("keydown", handleKeyDown, true);
    }, [handleClickGoTo]);
};
